/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import change pic
import TrackingPengajuanList from '../views/tracking-pengajuan/TrackingPengajuanList.vue';
import TrackingPengajuanDetail from '../views/tracking-pengajuan/TrackingPengajuanDetail.vue';

import { setBreadcrumb } from './index';

const trackingPengajuanRoute = {
  path: '/tracking-pengajuan',
  name: 'TrackingPengajuan',
  meta: {
    title: 'BNI QRIS - Tracking Pengajuan',
    appBarTitle: 'Tracking Pengajuan',
  },
  component: Parent,
  children: [
    {
      path: '/tracking-pengajuan/list',
      meta: {
        title: 'BNI QRIS - List Tracking Pengajuan',
        appBarTitle: 'List Tracking Pengajuan',
        breadcrumbs: () => [
          setBreadcrumb('tracking pengajuan', '/tracking-pengajuan', true),
          setBreadcrumb('list pengajuan', '/tracking-pengajuan/list'),
        ],
      },
      component: TrackingPengajuanList,
      name: 'TrackingPengajuanList',
    },
    {
      path: '/tracking-pengajuan/list/view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - View Detail',
        appBarTitle: 'View Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('tracking pengajuan', '/tracking-pengajuan', true),
            setBreadcrumb('list pengajuan', '/tracking-pengajuan/list'),
            setBreadcrumb('view', '/tracking-pengajuan/list/view', true),
            setBreadcrumb(`${id}`, `/tracking-pengajuan/list/view/${id}`, true),
          ];
        },
      },
      component: TrackingPengajuanDetail,
      name: 'TrackingPengajuanDetail',
    },
  ],
};
export default trackingPengajuanRoute;
